import { render, staticRenderFns } from "./personalWait.vue?vue&type=template&id=b88d7c1c&scoped=true"
import script from "./personalWait.vue?vue&type=script&lang=js"
export * from "./personalWait.vue?vue&type=script&lang=js"
import style0 from "./personalWait.vue?vue&type=style&index=0&id=b88d7c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d7c1c",
  null
  
)

export default component.exports